class AppError {
  constructor({ code = '', message = '', details = '' } = {}) {
    this.code = code;
    this.message = message;
    this.details = details;
  }

  static fromJson(json) {
    return new AppError({
      code: json.code,
      message: json.message,
      details: json.details,
    });
  }

  toJSON() {
    return {
      code: this.code,
      message: this.message,
      details: this.details,
    };
  }

  // Hata tipleri için static kodlar
  static VALIDATION_ERROR = 'VALIDATION_ERROR';
  static UNEXPECTED_ERROR = 'UNEXPECTED_ERROR';
  static NOT_FOUND_ERROR = 'NOT_FOUND_ERROR';
  static NETWORK_ERROR = 'NETWORK_ERROR';

  // Hata mesaj kodları için static kodlar
  static ERROR_TRANSLATION_FAILED = 'signup.error.translation-failed';
  static ERROR_FORM_SUBMISSION_FAILED = 'signup.error.form-submission-failed';
  static ERROR_EMAIL_CHANGE_FAILED = 'signup.error.email-change-failed';
  static ERROR_PASSWORD_VALIDATION_FAILED = 'signup.error.password-validation-failed';
  static ERROR_PASSWORD_SAVE_FAILED = 'signup.error.password-save-failed';
  static ERROR_COMPLETE_LATER_FAILED = 'signup.error.complete-later-failed';
  static ERROR_PERSONAL_INFO_VALIDATION_FAILED = 'signup.error.personal-info-validation-failed';
  static ERROR_PERSONAL_INFO_SAVE_FAILED = 'signup.error.personal-info-save-failed';
  static ERROR_ABOUT_ME_VALIDATION_FAILED = 'signup.error.about-me-validation-failed';
  static ERROR_ABOUT_ME_SAVE_FAILED = 'signup.error.about-me-save-failed';
  static ERROR_IMAGE_UPLOAD_FAILED = 'signup.error.image-upload-failed';
  static ERROR_CATEGORIES_VALIDATION_FAILED = 'signup.categories-desc';
  static ERROR_CATEGORIES_SAVE_FAILED = 'signup.error.categories-save-failed';
  static ERROR_CERTIFICATES_VALIDATION_FAILED = 'signup.error.certificates-validation-failed';
  static ERROR_CERTIFICATES_SAVE_FAILED = 'signup.error.certificates-save-failed';
  static ERROR_SUMMARY_VALIDATION_FAILED = 'signup.error.summary-validation-failed';
  static ERROR_SUMMARY_SAVE_FAILED = 'signup.error.summary-save-failed';
  static ERROR_CATEGORY_FILTER_FAILED = 'search.error.category-filter-failed';
  static ERROR_CATEGORY_SELECTION_FAILED = 'search.error.category-selection-failed';
  static ERROR_CATEGORY_EXPAND_FAILED = 'search.error.category-expand-failed';
  static ERROR_SEARCH_TERM_UPDATE_FAILED = 'search.error.search-term-update-failed';
  static ERROR_SEARCH_FILTER_RESET_FAILED = 'search.error.search-filter-reset-failed';
  static ERROR_SEARCH_SUBMIT_FAILED = 'search.error.search-submit-failed';

  // Profile error codes
  static ERROR_PROFILE_LOAD_FAILED = 'profile.error.load-failed';
  static ERROR_PROFILE_UPDATE_FAILED = 'profile.error.update-failed';

  // Factory metodlar güncellendi
  static unexpectedError(code = this.ERROR_FORM_SUBMISSION_FAILED, error = null) {
    return new AppError({
      code: this.UNEXPECTED_ERROR,
      message: code,
      details: error?.message || error?.toString() || '',
    });
  }

  static validationError(message) {
    return new AppError({
      code: this.VALIDATION_ERROR,
      message,
    });
  }

  // Hata tipini kontrol etmek için yardımcı metodlar
  isUnexpectedError() {
    return this.code === AppError.UNEXPECTED_ERROR;
  }

  isValidationError() {
    return this.code === AppError.VALIDATION_ERROR;
  }
}

export default AppError;
